module.exports = __webpack_public_path__ + "img/Logo-Up-Romania.ea2d96a5.svg";